import { useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import { getCookie, createCookie } from "../../../../common/utils/cookieUtils";

// Storage key for language preference
const STORAGE_KEY = "preferred_language";

/**
 * Hook for managing language persistence using cookies
 */
export function useLanguagePersistence() {
  const { supportedLanguages } = useSelector(
    (state: RootState) => state.language
  );

  // Function to save language preference
  const saveLanguagePreference = useCallback(
    (lang: string) => {
      if (
        Array.isArray(supportedLanguages) &&
        supportedLanguages.includes(lang)
      ) {
        createCookie(STORAGE_KEY, lang);
      }
    },
    [supportedLanguages]
  );

  // Function to get saved language
  const getSavedLanguage = useCallback(() => {
    return getCookie(STORAGE_KEY);
  }, []);

  return {
    saveLanguagePreference,
    getSavedLanguage,
  };
}
